import TurtleIcon from "../AssistantWidget/TurtleIcon";
import styles from "./logo.module.scss";

// NihongoTech's brand mark: かめ's turtle glyph + wordmark shown in the site
// header (see HeaderComponent.tsx, which wraps this in a NavLink to "/").
function Logo() {
    return (
        <div className={styles.logoContainer}>
            <div className={styles.iconWrapper}>
                <TurtleIcon size={40} className={styles.icon} />
            </div>
            <div className={styles.titleGroup}>
                <p className={styles.title}>
                    NihongoTech <span className={styles.byline}>by TeqSeq</span>
                </p>
                <span className={styles.subtitle}>日本語オンラインキーボード</span>
            </div>
        </div>
    );
}

export default Logo;
